import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";

interface SuccessResponseData {
	auto_accept_apps: boolean;
	/** When true, scraper may overwrite existing certificates (DAI-1239 / DAI-1240). */
	auto_overwrite_cert: boolean;
	/** ISO timestamp when present on the API response */
	last_updated_at?: string;
}

export type BuyerPreferencesUpdateBody = {
	auto_accept_apps?: boolean;
	auto_overwrite_cert?: boolean;
};

export type IGetBuyerPreferencesResponse = IResponse<SuccessResponseData>;
export type IUpdateBuyerPreferencesResponse = IResponse<SuccessResponseData>;

export async function getBuyerPreferences(): Promise<IGetBuyerPreferencesResponse> {
	return await apiRequest<SuccessResponseData>({
		path: "/api/buyer-preferences",
		method: "GET",
	});
}

export async function updateBuyerPreferences(
	body: BuyerPreferencesUpdateBody,
): Promise<IUpdateBuyerPreferencesResponse> {
	return await apiRequest<SuccessResponseData>({
		path: "/api/buyer-preferences",
		method: "PUT",
		json: body,
	});
}
